import ErpProductAttributeList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/product_attributes") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpProductAttributeList();
    }
}